<tds-theme name="scania"></tds-theme>
<div class="tds-navbar-overlay" [ngClass]="{ expanded: isExpanded }"></div>
<app-header class="app-header"></app-header>
<div class="sdds-push">
  <app-main></app-main>
  <app-ip-info></app-ip-info>
  <app-loader></app-loader>
</div>
<app-footer class="footer"></app-footer>
